"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _index = _interopRequireDefault(require("../../renderings/JssForm/index"));
var _imageSrc = require("../../lib/imageSrc");
var _CTAButton = _interopRequireDefault(require("../../components/CTAButton"));
var _lodash = require("lodash");
var _AgentProfile = _interopRequireDefault(require("../../components/finpro/AgentProfile"));
var _FinproProfileUtility = require("../../components/finpro/FinproProfileUtility");
var _utils = require("../../utils");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _LeadFormModal = _interopRequireDefault(require("../../components/finpro/LeadFormModal"));
var _FinproHeadTags = _interopRequireDefault(require("../../components/finpro/headtag/FinproHeadTags"));
var _LeadFormData = require("../../components/finpro/LeadFormData");
var _constants = require("../../utils/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 *  A react component to create a Agent Profile
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering.fields.data Agent detail
 *
 * @returns {React.ReactElement} Agent profile
 */
function FinproAgentProfile(props) {
  if (!props.rendering.fields || !props.rendering.fields.data) {
    return null;
  }
  var extractedFields = (0, _lodash.get)(props, 'rendering.fields.data');
  var showForm = extractedFields.showLeadForm && props.formParams;
  var profilePhoto = (0, _imageSrc.finproProfileImageHref)(extractedFields.profileImage);
  (0, _LeadFormData.setFinproLeadFormData)({
    agentId: extractedFields.agentId,
    coreAgencyNumber: extractedFields.agency.coreAgencyNumber,
    subAgencyNumber: extractedFields.agency.subAgencyNumber,
    agencyName: extractedFields.agency.agencyName
  });

  // Lead Form Modal event
  var [showLeadForm, setLeadForm] = (0, _react.useState)(false);
  var [leadFormData, setLeadFormData] = (0, _react.useState)(null);
  var handleLeadFormModalShow = props => {
    setLeadForm(true);
    setLeadFormData(props);
  };
  var handleLeadFormModalClose = () => {
    setLeadForm(false);
    setLeadFormData(null);
  };
  var ProcessHeadtags = () => {
    if (extractedFields.agency.location) {
      var bio = extractedFields.agentBio.bioText;
      if (extractedFields.agentBio.bioTags) bio = bio + extractedFields.agentBio.bioTags.map(x => x.key + x.value);
      var metadata = {
        pagePath: extractedFields.agentUrl,
        pageQuery: props.params.pageQuery,
        utagSiteName: props.pageprops.utagSiteName,
        addUtagLoginCookie: props.pageprops.addUtagLoginCookie,
        name: extractedFields.fullName,
        location: extractedFields.agency.location,
        phone: extractedFields.workPhone,
        profilePic: profilePhoto,
        bio: bio,
        agentTitle: extractedFields.agentTitle
      };
      return /*#__PURE__*/_react.default.createElement(_FinproHeadTags.default, {
        pageType: 'agent',
        metadata: metadata
      });
    } else {
      var _metadata = {
        pagePath: props.params.pagePath
      };
      return /*#__PURE__*/_react.default.createElement(_FinproHeadTags.default, {
        pageType: 'default',
        metadata: _metadata
      });
    }
  };
  var GetLeadFormLink = () => {
    var label = "Connect with ".concat(extractedFields.firstName);
    var formProps = {
      coreAgencyNumber: extractedFields.agency.coreAgencyNumber,
      subAgencyNumber: extractedFields.agency.subAgencyNumber,
      agentId: extractedFields.agentId,
      agencyName: extractedFields.agency.agencyName,
      modalTitle: label
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "connect-form"
    }, /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
      buttonType: 'inline',
      label: label,
      dataId: (0, _FinproProfileUtility.GetCTADataId)(_constants.LEADS_CTA_LABEL, extractedFields.agentUrl),
      icon: 'icon-ask',
      iconDirection: 'left',
      onClick: () => handleLeadFormModalShow(formProps)
    }));
  };
  var GetEmailLink = () => {
    var subject = 'MassMutual Financial Professional&body=Here is a link to the MassMutual Financial professional I found:';
    return /*#__PURE__*/_react.default.createElement("a", {
      className: "btn btn-link",
      href: "mailto:?subject=".concat(subject, " ").concat((0, _utils.getMMDomainUrl)(extractedFields.agentUrl)),
      rel: "noopener noreferrer",
      target: "_blank"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "icon-share"
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "sr-only"
    }, "email"));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "app-container finpro-agent-profile"
  }, /*#__PURE__*/_react.default.createElement(ProcessHeadtags, null), /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-spacing--minor"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Jumbotron, {
    variant: "dark-primary"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-media-object reverse"
  }, /*#__PURE__*/_react.default.createElement("picture", {
    className: "mm-img-circle--xl"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: profilePhoto,
    alt: "MassMutual financial professional."
  })), /*#__PURE__*/_react.default.createElement("section", {
    className: "mm-desktop-tablet-only"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "body"
  }, !(0, _lodash.isEmpty)(extractedFields.fullName) && /*#__PURE__*/_react.default.createElement("h2", null, extractedFields.fullName, /*#__PURE__*/_react.default.createElement(GetEmailLink, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "profile-contact-link"
  }, !(0, _lodash.isEmpty)(extractedFields.workPhone) && /*#__PURE__*/_react.default.createElement(_FinproProfileUtility.GetPhone, {
    value: extractedFields.workPhone
  }), showForm && !extractedFields.isManagingAssociate && /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-tablet-mobile-only"
  }, /*#__PURE__*/_react.default.createElement(GetLeadFormLink, null)))))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "container mm-spacing--minor"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "mm-mobile-only"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, !(0, _lodash.isEmpty)(extractedFields.fullName) && /*#__PURE__*/_react.default.createElement("h2", {
    className: "mm-text-center"
  }, /*#__PURE__*/_react.default.createElement("span", null, extractedFields.fullName), /*#__PURE__*/_react.default.createElement(GetEmailLink, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "profile-contact-link"
  }, !(0, _lodash.isEmpty)(extractedFields.workPhone) && /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
    buttonType: 'inline',
    label: extractedFields.workPhone,
    dataId: 'contact',
    icon: 'icon-call',
    iconDirection: 'left',
    href: "tel:+1".concat(extractedFields.workPhone)
  }), showForm && !extractedFields.isManagingAssociate && /*#__PURE__*/_react.default.createElement(GetLeadFormLink, null)), /*#__PURE__*/_react.default.createElement("hr", null))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: showForm ? 7 : 12,
    md: 12,
    sm: 12
  }, /*#__PURE__*/_react.default.createElement(_AgentProfile.default, extractedFields)), showForm && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 5,
    className: "mm-desktop-only"
  }, /*#__PURE__*/_react.default.createElement("fieldset", {
    className: "card"
  }, /*#__PURE__*/_react.default.createElement("fieldset", {
    className: "card-body"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "mm-text-center"
  }, "Connect with ".concat(extractedFields.firstName)), /*#__PURE__*/_react.default.createElement(_index.default, {
    renderings: props.formParams,
    fields: props.formParams.fields,
    params: props.formParams.params
  })))))), showForm && !extractedFields.isManagingAssociate && /*#__PURE__*/_react.default.createElement(_LeadFormModal.default, {
    formData: props.formParams,
    show: showLeadForm,
    data: leadFormData,
    onModelClose: handleLeadFormModalClose
  }));
}
var _default = exports.default = FinproAgentProfile;